import { parseAsArrayOf, parseAsIsoDateTime, parseAsString, useQueryStates } from 'nuqs';

export default function useExamDistributionSearchParams() {
  const [{ examDate, examCenters, provinces }, setExamDistributionSearchParams] = useQueryStates({
    examDate: parseAsIsoDateTime,
    examCenters: parseAsArrayOf(parseAsString).withDefault([]),
    provinces: parseAsArrayOf(parseAsString).withDefault([]),
  });

  const changeExamDate = (examDate: Date | null) => {
    setExamDistributionSearchParams({ examDate });
  };

  const changeExamCenters = (examCenters: string[] | null) => {
    setExamDistributionSearchParams({ examCenters });
  };

  const changeProvinces = (provinces: string[] | null) => {
    setExamDistributionSearchParams({ provinces });
  };

  return [
    { examDate, examCenters, provinces },
    {
      changeExamDate,
      changeExamCenters,
      changeProvinces,
    },
  ] as const;
}
